/**
 * A wheelie bin, in the same hand-drawn style as the nav glyphs.
 *
 * Shape is what separates a bin collection from an appointment — colour only
 * says *which* bin. Member colours are hues on a ring and bin colours are
 * semantic, so the two palettes will collide sooner or later; leaning on
 * colour alone to carry the category would make that collision ambiguous.
 */
export function WasteIcon({ size = 22 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M5.5 7.5h13l-1 12.5a1.5 1.5 0 0 1-1.5 1.4H8a1.5 1.5 0 0 1-1.5-1.4Z" />
      <path d="M4 7.5h16" />
      <path d="M9.5 7.5V4.6a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v2.9" />
    </svg>
  );
}
